import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { initAnalytics, trackEvent } from "@/lib/analytics";
import TopBar from "@/components/TopBar";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import HowItWorks from "@/components/HowItWorks";
import Benefits from "@/components/Benefits";
import Sensory from "@/components/Sensory";
import Models from "@/components/Models";
import Personalization from "@/components/Personalization";
import Comparison from "@/components/Comparison";
import Specs from "@/components/Specs";
import Story from "@/components/Story";
import Audience from "@/components/Audience";
import Warranty from "@/components/Warranty";
import Shipping from "@/components/Shipping";
import BackgroundVideo from "@/components/BackgroundVideo";
import InstagramFeed from "@/components/InstagramFeed";
import Faq from "@/components/Faq";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    initAnalytics();
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const fired = { s50: false, s90: false };
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const pct = (window.scrollY / max) * 100;
      if (!fired.s50 && pct >= 50) {
        fired.s50 = true;
        trackEvent("scroll_50", { page_path: window.location.pathname });
      }
      if (!fired.s90 && pct >= 90) {
        fired.s90 = true;
        trackEvent("scroll_90", { page_path: window.location.pathname });
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="relative min-h-screen bg-ink text-bone">
      <BackgroundVideo />
      <TopBar />
      <Header />
      <main>
        <Hero />
        <div className="relative z-10 bg-ink">
          <Marquee />
          <Problem />
          <HowItWorks />
          <Benefits />
          <Sensory />
          <Models />
          <Personalization />
          <Comparison />
          <Specs />
          <Story />
          <Audience />
          <Warranty />
          <Shipping />
          <InstagramFeed />
          <Faq />
          <FinalCTA />
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
